import { FC } from 'react';

export const MarshallReddickLogo: FC<{ className?: string }> = ({ className = '' }) => {
  const websiteUrl = import.meta.env.VITE_WEBSITE_URL as string | undefined;

  return (
    <svg
      viewBox="0 0 951 703.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={() => {
        if (!websiteUrl) return;
        window.location.href = websiteUrl;
      }}
      style={{ cursor: 'pointer' }}
    >
      <polygon
        fill="#FCFCFC"
        points="164.5,646 190.3,646 195.5,328 305.7,544.5 332.4,544.5 443.7,328 
      448.7,646 474.9,646 465.3,285.4 439.6,285.4 319.7,521.1 200.6,285.4 174.9,285.4 "
      />
      <rect x="548.7" y="304.4" fill="#FCFCFC" width="25.7" height="339.4" />
      <g>
        <path
          fill="#FCFCFC"
          stroke="#FCFCFC"
          d="M737.9,395.9c-2.7,65.3-48.9,79.7-76.4,82.4
        c-4,0.4-7,0.4-8.4,0.4l-1.7,0l-77,0v-82.9h-25.7v108.5l102.1,0c0,0,5.3,0.2,13.1-0.5
        c22.7-2.2,96.4-16.6,99.6-108H737.9z"
        />
        <path
          fill="#FCFCFC"
          stroke="#FCFCFC"
          d="M737.9,395.8c-2.7-65.3-48.9-79.7-76.4-82.4
        c-4-0.4-7-0.4-8.4-0.4l-1.7,0l-77,0v82.9h-25.7V287.3l102.1,0c0,0,5.3-0.2,13.1,0.5
        c22.7,2.2,96.4,16.6,99.6,108H737.9z"
        />
      </g>
      <polygon fill="#FCFCFC" points="767.2,653.3 661.7,501.8 682.7,487.1 788.3,638.6" />
      <polygon
        fill="#FCFCFC"
        points="903.6,311.9 667.5,223.5 667.5,138.6 574.4,138.6 574.4,191.6 
      322,93.4 51.5,309.9 35.5,289.9 317.5,64.1 548.7,154.1 548.7,113 693.1,113 
      693.1,205.7 912.6,287.9"
      />
    </svg>
  );
};

export const EyeIcon: FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    width="29"
    height="29"
    viewBox="-7 -7 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs>
      <clipPath id="rounded">
        <rect x="-7" y="-7" width="29" height="29" rx="6" />
      </clipPath>
    </defs>

    <g clipPath="url(#rounded)">
      <rect x="-7" y="-7" width="29" height="29" />
      <path
        d="M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const EyeOffIcon: FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    width="29"
    height="29"
    viewBox="-7 -7 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs>
      <clipPath id="rounded">
        <rect x="-7" y="-7" width="29" height="29" rx="6" />
      </clipPath>
    </defs>

    <g clipPath="url(#rounded)">
      <rect x="-7" y="-7" width="29" height="29" />
      <path
        d="M13.3536 2.64645C13.5488 2.84171 13.5488 3.15829 13.3536 3.35355L3.35355 13.3536C3.15829 13.5488 2.84171 13.5488 2.64645 13.3536C2.45118 13.1583 2.45118 12.8417 2.64645 12.6464L12.6464 2.64645C12.8417 2.45118 13.1583 2.45118 13.3536 2.64645Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const ChevronLeftIcon: FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 20 20"
    aria-hidden="true"
    data-cy="forgot-password-login-link"
    className={`inline mb-0.5 ${className}`}
    height="16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const CheckCircleIcon: FC<{ className?: string }> = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExclamationCircleIcon: FC<{ className?: string }> = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM11.25 13.5V8.25H12.75V13.5H11.25ZM11.25 15.75V14.25H12.75V15.75H11.25Z"
      fill="currentColor"
    />
  </svg>
);

export const CheckCircleFilledIcon: FC<{ className?: string }> = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z"
      fill="currentColor"
    />
  </svg>
);
